import { render, staticRenderFns } from "./PropertyValuableFieldset.vue?vue&type=template&id=23b55e58&scoped=true"
import script from "./PropertyValuableFieldset.vue?vue&type=script&lang=js"
export * from "./PropertyValuableFieldset.vue?vue&type=script&lang=js"
import style0 from "./PropertyValuableFieldset.vue?vue&type=style&index=0&id=23b55e58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b55e58",
  null
  
)

export default component.exports